import { FlatPickrDirective } from './../../plugins/flatpickr/flatpickr.directive';
import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges, NgZone } from '@angular/core';
import { IKeyValueInterface, BookingStatus } from './../../shared/config';
import { BookingTripDetail, BookingInformation } from "../models/booking-information.model";
import { Router } from "@angular/router";
import { FlatPickrModel } from './../../plugins/flatpickr/flatpickr.model';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL } from '../../shared/config';
import { UnlockService } from "../models/unlock.service";
import { BookingService } from './../models/booking.service';

const moment = require("moment");

@Component({
  selector: 'wego-bookingtrip-detail-popup',
  template: require('../views/bookingtrip-detail-popup.component.html'),
})

export class BookingTripDetailpopupComponent implements OnInit {

  public isLoading: boolean;
  public headers: any;
  public errorModel: IKeyValueInterface[];
  public errorMsg: string;
  public model: BookingTripDetail = new BookingTripDetail();
  public contractTypeGroupList: any;
  flatPickrConfigFrom: FlatPickrModel;
  flatPickrConfigTo: FlatPickrModel;
  public dateFormat: string = "d-m-Y H:i:S";
  public startDate: string;
  public endDate: string;

  @ViewChild('bookingTripDetailModal') public bookingTripDetailModal: any;
  @ViewChild('flatPickrConfigStartDate') public flatPickrConfigStartDate: FlatPickrDirective;
  @ViewChild('flatPickrConfigEndDate') public flatPickrConfigEndDate: FlatPickrDirective;

  @Output('OnSuccessSave') onSuccessSave = new EventEmitter();
  @Input('BookingHashId') bookingHashId: any;
  @Input('BookingInfoModel') bookingInfoModel: any;

  constructor(private authService: AuthService
    , private router: Router
    , private translate: TranslateService, private unlockService: UnlockService, private zone: NgZone, private bookingService: BookingService) {

  }

  ngOnInit() {
    this.headers = this.authService.GetHeaderForFile();
    this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();

    this.model.startDateTime = moment().format('DD-MM-YYYY 00:00');
    this.model.endDateTime = moment().add(+1, 'M').format('DD-MM-YYYY 00:00');
    this.GetContactTypeGroup();
  }

  private SetDefaultFlatPickrConfig(isDateOnly?: boolean) {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = true;
    flatPickrConfig.enableSeconds = true;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.dateFormat = this.dateFormat;
    flatPickrConfig.minuteIncrement = 1;    
    return flatPickrConfig;
  }

  public show(): void {
    this.errorMsg = '';
    this.errorModel = [];
    let newDate = moment(this.bookingInfoModel.allowedStartDateTime, "DD-MM-YYYY HH:mm:ss").toDate();
    this.flatPickrConfigStartDate.SetOption("minDate", newDate);
    this.model.BookingHashId = this.bookingHashId;
    this.bookingTripDetailModal.show();
  }

  public OnFromDateChange(value: string) {
    if (value) {
      let format = 'DD-MM-YYYY HH:mm:ss';
      let newDate = moment(value, format).toDate();
      let endDate = moment(this.model.endDateTime, format).toDate();
      let endDateVal = moment(value, format);

      if (endDate < newDate) {
        endDateVal = endDateVal.add('H', 1);
        this.flatPickrConfigEndDate.ChangeValue(endDateVal.format('DD-MM-YYYY HH:mm:ss'));
      }
      this.flatPickrConfigEndDate.SetOption("minDate", newDate);
    }
  }

  public GetContactTypeGroup() {
    this.unlockService.GetContactTypeGroupList(this.bookingHashId)
      .subscribe(
      (res: any) => {
        this.contractTypeGroupList = res.data;
      },
      (error: any) => {
      });
  }

  public hide(): void {
    this.model = new BookingTripDetail();
    this.bookingTripDetailModal.hide();
  }

  private OnSuccessSave() {
    this.hide();
    let successMsg = this.translate.instant('LblTripSuccess');
    this.onSuccessSave.emit({ SuccessMessage: successMsg })
  }

  public OnSubmit(forms: any) {
    console.log(this.model);
    if (this.model) {

      this.bookingService.UpdateBookingTrip(this.model).subscribe(
        res => {
          this.isLoading = false;
          if (res.data) {
            this.OnSuccessSave();
          }
          else {

            this.errorModel = res.error;
            this.errorMsg = res.error;
          }
        },
        error => {
          this.errorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        });
    }
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking/components/bookingtrip-detail-popup.component.ts